import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown as AntDropdown } from 'antd';
import './Dropdown.scss';

/**
 * Reusable design-system wrapper around Ant Design Dropdown.
 *
 * The wrapper keeps Ant Design's menu API while providing stable overlay
 * classes and visual variants that can be reused across product surfaces.
 */
const Dropdown = ({
    children,
    menu,
    classNames,
    overlayClassName = '',
    variant = 'default',
    trigger = ['click'],
    ...props
}) => {
    const overlayClasses = [
        'ds-dropdown-overlay',
        `ds-dropdown-overlay--${variant}`,
        overlayClassName,
        classNames?.root,
    ].filter(Boolean).join(' ');

    const semanticClassNames = {
        ...classNames,
        root: overlayClasses,
    };

    return (
        <AntDropdown
            menu={menu}
            classNames={semanticClassNames}
            trigger={trigger}
            {...props}
        >
            {children}
        </AntDropdown>
    );
};

Dropdown.propTypes = {
    children: PropTypes.node.isRequired,
    menu: PropTypes.object,
    classNames: PropTypes.object,
    overlayClassName: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'workspace']),
    trigger: PropTypes.arrayOf(PropTypes.oneOf(['click', 'hover', 'contextMenu'])),
};

export default Dropdown;
